import axios from "axios";
import config from "../config";
import { getCookies } from "../utils/utilsFunctions";

export const authenticatedInstance = axios.create({
  baseURL: config.API_URL,
  headers: {
    authorization: getCookies(),
  },
});
export const unauthenticatedInstance = axios.create({
  baseURL: config.API_URL,
});
